function initMenuHover() {
  // Solo para desktop
  if (window.innerWidth < 990) return;

  const menuContainer = document.querySelector('.header__inline-menu');
  if (!menuContainer) return;

  // Desactivar comportamiento nativo de click
  const megaMenus = menuContainer.querySelectorAll('.mega-menu');
  megaMenus.forEach(menu => {
    const summary = menu.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', e => e.preventDefault());
    }
  });

  // Activar hover
  const menuItems = menuContainer.querySelectorAll('.header__menu-item, .mega-menu');
  
  menuItems.forEach(item => {
    item.addEventListener('mouseenter', function() {
      const megaMenu = this.classList.contains('header__menu-item') 
        ? this.nextElementSibling 
        : this;
      
      if (megaMenu && megaMenu.classList.contains('mega-menu')) {
        megaMenu.setAttribute('open', '');
      }
    });
    
    item.addEventListener('mouseleave', function() {
      const megaMenu = this.classList.contains('header__menu-item')
        ? this.nextElementSibling
        : this;
      
      if (megaMenu && megaMenu.classList.contains('mega-menu')) {
        setTimeout(() => {
          if (!megaMenu.matches(':hover')) {
            megaMenu.removeAttribute('open');
          }
        }, 100);
      }
    });
  });
}

// Inicialización mejorada
if (document.readyState === 'complete') {
  initMenuHover();
} else {
  document.addEventListener('DOMContentLoaded', initMenuHover);
}

// Re-inicializar al cambiar tamaño
window.addEventListener('resize', function() {
  if (window.innerWidth >= 990) {
    initMenuHover();
  }
});